import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const UnAuthorizedRoute = ({ children }: { children: ReactNode }) => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const user = useSelector((state: any) => state.user.user);
  console.log('user', user);
  console.log('isLoggedIn', isLoggedIn);

  return !isLoggedIn ? <>{children}</> : <Navigate to="/" />;
};

export default UnAuthorizedRoute; 